import React, { Component } from "react";
import Header from "../layout/headerHome";
import Footer from "../layout/footerUpdated";
import { Helmet } from "react-helmet";

const aboutbg = require("./../../assets/images/background/blog-bg.webp");

class News extends Component {
    constructor(props) {
        super(props);
        this.state = {
            news: [],
            currentPage: 1,
            newsPerPage: 9,
        };
    }

    componentDidMount() {
    document.title = "News & Media | Bridge Health";
    this.fetchNewsData();
    }

    fetchNewsData = () => {
    const siteUrl = "https://admin.bridgehealth.in";

    fetch(
        `${siteUrl}/api/news-medias?pagination[start]=0&pagination[limit]=999999&sort=PublishedDate:desc&populate=*`
    )
        .then((response) => response.json())
        .then((data) => {
            const news = data.data.map((item) => ({
                id: item.id,
                title: item.attributes.Title,
                link: item.attributes.Link,
                image: item.attributes.Image?.data?.attributes?.url,
                publishedDate: item.attributes.PublishedDate,
            }));

            this.setState({ news });
        })
        .catch((error) => console.error(error));
    };

    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber }, () => {
            window.scrollTo({ top: 400, behavior: "smooth" });
        });
    };

    render() {
        const { currentPage, newsPerPage, news } = this.state;

        const indexOfLastNews = currentPage * newsPerPage;
        const indexOfFirstNews = indexOfLastNews - newsPerPage;

        const currentNews = news.slice(indexOfFirstNews, indexOfLastNews);

        const totalPages = Math.ceil(this.state.news.length / newsPerPage);

        return (
            <>
                <Header />
                <Helmet>
                    <title>
                        Latest Health Media and News on preventive care, Corporate wellness | Bridge
                        Health
                    </title>
                    <meta
                        name="News & Media"
                        content="Explore our informative blog for the latest articles & insights on health, wellness, & medical advancements. Stay informed & empowered with Bridge Health's blog."
                    />
                </Helmet>
                {/* Page Banner Section */}
                <section className="page-bann" style={{ backgroundImage: `url(${aboutbg})`, backgroundSize: "cover" }}>
                    <h1 className="colorwhite outline">NEWS & MEDIA</h1>
                </section>

                {/* News Section */}
                <section className="news-section py-5">
                    <div className="container">

                        <div className="row g-4">

                            {currentNews.map((item) => (
                                <a
                                    className="blog-item d-block col-lg-4"
                                    key={item.id}
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "none" }}
                                >
                                    <div className="image-wrap overflow-hidden">
                                        <img
                                            className="w-100"
                                            src={`https://admin.bridgehealth.in${item.image}`}
                                            alt={item.title}
                                            style={{
                                                height: "250px",
                                                width: "100%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    </div>

                                    <article className="p-3">
                                        <span
                                            style={{
                                                fontSize: "14px",
                                                color: "#8a8a8a",
                                                display: "block",
                                                marginBottom: "8px",
                                            }}
                                        >
                                            {new Date(item.publishedDate).toLocaleDateString("en-IN", {
                                                day: "numeric",
                                                month: "long",
                                                year: "numeric",
                                            })}
                                        </span>

                                        <h4
                                            style={{
                                                color: "#0d0d0d",
                                                fontSize: "18px",
                                                lineHeight: "1.4",
                                                fontWeight: 600,
                                                marginBottom: 0,
                                            }}
                                        >
                                            {item.title}
                                        </h4>
                                    </article>
                                </a>
                            ))}

                        </div>

                    </div>
                </section>

                {totalPages > 1 && (
                    <div className="pagination-wrap text-center mt-4">
                        <button
                            className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
                            onClick={() => currentPage > 1 && this.handlePageChange(currentPage - 1)}
                        >
                            Prev
                        </button>

                        {Array.from({ length: totalPages }).map((_, index) => (
                            <button
                                key={index + 1}
                                onClick={() => this.handlePageChange(index + 1)}
                                className={`pagination-btn ${
                                    currentPage === index + 1 ? "active" : ""
                                }`}
                            >
                                {index + 1}
                            </button>
                        ))}

                        <button
                            className={`pagination-btn ${
                                currentPage === totalPages ? "disabled" : ""
                            }`}
                            onClick={() =>
                                currentPage < totalPages &&
                                this.handlePageChange(currentPage + 1)
                            }
                        >
                            Next
                        </button>
                    </div>
                )}

                <Footer />
            </>
        );
    }
}

export default News;
